<template lang="pug">
  .activity-assigned
    .row
      .col
        .activity-avatar
          UserAvatar(:user="activity.user")
      .col.max
        .activity-header
          .row.apart
            .col(v-if="activity.boardWas")
              span.creator {{ activity.user.fullName }} moved from {{ activity.boardWas }}
            .col
              span.created {{ activity.created | moment("from") }}

        .activity-body(v-if="activity.comment", v-html="commentFormatted")

</template>

<script>

const urlRegex = /(https?:\/\/[^\s]+)/g

export default {
  name: 'ActivityMoved',
  props: {
    activity: Object
  },
  mounted () {
    //console.log(this.activity)
  },
  computed: {
    commentFormatted () {
      let comment = ''
      if (this.activity.comment) {
        comment = this.activity.comment.replace(/\n/g, '<br/>')
        comment = comment.replace(urlRegex, '<a target="_blank" href="$1">$1</a>')
      }
      return comment
    }
  }
}
</script>

<style scoped lang="stylus">
  .activity-assigned
    border-bottom $border-default
    display block
    margin-bottom $spacing
    padding $spacing-4 0

    .activity-header
      color $text-light

    .creator
      font-size $text-size-small
      line-height $text-size-default
    .created
      font-size $text-size-smaller
      line-height $text-size-default

    .activity-avatar
      width 50px

    .activity-body
      color $text-light
      line-height 22px
      margin-bottom $spacing
      padding $spacing-2 0
      a
        &:hover
          text-decoration underline

</style>
